import React from 'react';
import SEO from '../../components/ui/SEO';
import ServicePageTemplate from '../../components/ui/ServicePageTemplate';
import { servicePages } from '../../data/services';
export default function ClinicalNegligence() {
  return <main className="min-h-screen bg-white" data-id="element-1079" data-mp="15dlspebwy043">
      <SEO title="Clinical Negligence and Personal Injury Psychiatric Reports" description="Independent reports on psychiatric injury, causation, condition and prognosis in clinical negligence and personal injury claims. Request a fee quote." path="/services/clinical-negligence" keywords={['psychiatric report for clinical negligence', 'personal injury psychiatric report', 'condition and prognosis psychiatric report']} imageAlt="Psychiatric reports for clinical negligence and personal injury claims" schema={{
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Clinical Negligence and Personal Injury Psychiatric Reports',
      serviceType: 'Clinical negligence psychiatric assessment',
      url: 'https://medicolegal-psychiatry.co.uk/services/clinical-negligence',
      areaServed: {
        '@type': 'AdministrativeArea',
        name: 'England and Wales'
      },
      provider: {
        '@type': 'Organization',
        name: 'Medicolegal Psychiatry',
        url: 'https://medicolegal-psychiatry.co.uk'
      },
      audience: {
        '@type': 'Audience',
        name: 'Legal professionals'
      },
      description: 'Psychiatric opinion on psychiatric injury, causation, condition and prognosis in clinical negligence and personal injury claims.'
    }} data-id="element-1080" data-mp="1abdm6cs7huae" />
      <ServicePageTemplate content={servicePages.clinicalNegligence} data-id="element-1081" data-mp="2oul0qqa8iim1" />
    </main>;
}